import { render, staticRenderFns } from "./CoreInfo.vue?vue&type=template&id=42c3fa4b&lang=pug&"
import script from "./CoreInfo.vue?vue&type=script&lang=js&"
export * from "./CoreInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports